<div ngbDropdown container="body">
  <button id="route-action-menu"
          appBringozIdGenerator="menu-button-route-routes-panel"
          (click)="$event.stopPropagation();"
          [disabled]="isMenuDisabled"
          ngbDropdownToggle>
    <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
  </button>
  <div ngbDropdownMenu aria-labelledby="route-action-menu">
    <button
      *ngIf="route?.status !== 'DISPATCHED'"
      ngbDropdownItem
      appBringozIdGenerator="dispatch-route-menu-routes-panel"
      type="tertiary"
      (click)="onDispatch.emit(route.id); $event.stopPropagation()">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="dispatch" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400">{{ 'Dispatch' | translate }}</span>
      </div>
    </button>

    <button
      *ngIf="(!route?.locked && !isRunning)"
      ngbDropdownItem
      appBringozIdGenerator="reoptimize-route-menu-routes-panel"
      type="tertiary"
      (click)="onReoptimize.emit(route.id); $event.stopPropagation()">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="reoptimize" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400">{{ 'Reoptimize' | translate }}</span>
      </div>
    </button>

    <button
      *ngIf="(!route?.locked && route.status !== 'DISPATCHED' && !isRunning)"
      ngbDropdownItem
      type="tertiary"
      (click)="onPreAssignAgent.emit(route.id); $event.stopPropagation()">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="assign" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400">{{ 'Pre-Assign Agent' | translate }}</span>
      </div>
    </button>

    <button
      *ngIf="route?.status === 'DISPATCHED'"
      ngbDropdownItem
      type="tertiary"
      (click)="onPrint.emit(route.id); $event.stopPropagation()">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="print" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400">{{ 'Print' | translate }}</span>
      </div>
    </button>

    <button ngbDropdownItem
            type="tertiary"
            appBringozIdGenerator="export-route-loading-sheet-route-menu-routes-panel"
            (click)="onPrintLoadingSheet.emit(route.id); $event.stopPropagation()">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="print" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400">{{ 'Export Route Loading Sheet' | translate }}</span>
      </div>
    </button>

    <button ngbDropdownItem
            type="tertiary"
            appBringozIdGenerator="like-route-menu-routes-panel"
            (click)="onFeedback.emit({routeId: route.id, feedback: route?.feedback === RouteFeedback.LIKE ? RouteFeedback.NEUTRAL : RouteFeedback.LIKE}); $event.stopPropagation()">
        <div class="layout-row layout-align-start-center">
          <bringoz-icon iconName="good"
                        [fill]="route?.feedback === RouteFeedback.LIKE ? '#266AFF' : '#7E7E7E'"
                        class="margin-right-10"
                        classSize="xl"></bringoz-icon>
          <span class="br-body-2"
                [class.feedback-liked]="route?.feedback === RouteFeedback.LIKE"
                translate>Like</span>
        </div>
     </button>

     <button ngbDropdownItem
             type="tertiary"
             appBringozIdGenerator="dislike-route-menu-routes-panel"
             (click)="onFeedback.emit({routeId: route.id, feedback: route?.feedback === RouteFeedback.DISLIKE ? RouteFeedback.NEUTRAL : RouteFeedback.DISLIKE}); $event.stopPropagation()">
       <div class="layout-row layout-align-start-center">
         <bringoz-icon iconName="bad"
                       [fill]="route?.feedback === RouteFeedback.DISLIKE ? '#D52424' : '#7E7E7E'"
                       class="margin-right-10"
                       classSize="xl"></bringoz-icon>
         <span class="br-body-2"
               [class.feedback-disliked]="route?.feedback === RouteFeedback.DISLIKE"
               translate>Dislike</span>
       </div>
     </button>

    <button ngbDropdownItem
            *ngIf="(!route?.locked && !isRunning)"
            appBringozIdGenerator="delete-route-menu-routes-panel"
            type="tertiary"
            (click)="deleteRoute($event)">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="close-circle" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
        <span class="br-body-2 font-weight-400" translate>Delete</span>
      </div>
    </button>
  </div>
</div>
